var React = require('react');

function Icon(props) {
  return React.cloneElement(
    React.createElement(
      'svg',
      { height: '24', width: '24', viewBox: '0 0 24 24' },
      React.createElement('path', {
        d:
          'M20.2502 3H3.75038C3.33581 3 3 3.33581 3 3.74981V20.2502C3 20.6642 3.33581 21 3.75038 21H12.5625V14.25H10.3125V11.4375H12.5625V9.1875C12.5625 6.86269 14.0346 5.71856 16.1085 5.71856C17.1019 5.71856 17.9557 5.79281 18.2044 5.82544V8.25544L16.7661 8.256C15.6382 8.256 15.375 8.79206 15.375 9.57844V11.4375H18.1875L17.625 14.25H15.375L15.42 21H20.2502C20.6642 21 21 20.6642 21 20.2502V3.74981C21 3.33581 20.6642 3 20.2502 3Z'
      })
    ),
    props
  );
}

module.exports = Icon;
